import React, { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import Group from 'components/utils/Group'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Container = styled.div`
  padding: ${rem(20)};

  ${mediaQueryUp.largeDesktop} {
    padding: ${rem(20)} 0;
  }
`

function BundleAndSaveCallUs() {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const supportContact = currentContact.defaultContact

  return (
    <Container>
      <Group gap={0} tabletGap={8} direction="vertical">
        <BodyText variant="large" weight="bold">
          {intl.formatMessage({
            id: '8e2mMTj5PYeO9P0LmMh5',
            defaultMessage: 'Want to mix and match room types?',
            description: 'Heading prompting users to call for mixed room type bundles',
          })}
        </BodyText>
        <Group direction="vertical" desktopDirection="horizontal" gap="12 0" desktopGap="0 12">
          <BodyText variant="medium" colour="neutral-three">
            {intl.formatMessage({
              id: '0gsjkFd-GP4dO6flKKxJ',
              defaultMessage: 'Call our customer service team 24 hours, 7 days.',
              description: 'Description for contacting customer service about bundle room types',
            })}
          </BodyText>
          <TextLink
            startIcon={<LinePhoneIcon />}
            size="medium"
            href={`tel:${supportContact.number}`}
          >
            {supportContact.humanReadable}
          </TextLink>
        </Group>
      </Group>
    </Container>
  )
}

export default BundleAndSaveCallUs
